import { useEffect, useState } from "react";

/**
 * Which white-label instance the dashboard is running as.
 *
 * This was duplicated across six files, each re-implementing
 * `window.location.href.includes("felix")` in its own useEffect. Besides the
 * repetition it meant no environment whose hostname lacks the brand word could
 * ever render its own branding — running locally fell back to the KMMRCE logo,
 * so the dashboard looked like a different product in development.
 *
 * Resolution order:
 *   1. REACT_APP_INSTANCE, so any deployment can state its brand outright
 *   2. the hostname, preserving existing behaviour
 */
const HOSTNAME_MATCHES = [
  ["felix", "felix"],
  ["incontrol", "in-control"],
  ["rokit", "rokit"],
  ["afritech", "starlink"],
];

export const resolveInstance = (href = "") => {
  const configured = (process.env.REACT_APP_INSTANCE || "").trim();
  if (configured) return configured;

  const target = href.toLowerCase();
  const match = HOSTNAME_MATCHES.find(([needle]) => target.includes(needle));
  return match ? match[1] : "";
};

export const useInstance = () => {
  const [instance, setInstance] = useState(() =>
    resolveInstance(typeof window !== "undefined" ? window.location.href : "")
  );

  useEffect(() => {
    setInstance(resolveInstance(window.location.href));
  }, []);

  return instance;
};

export default useInstance;
